/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { takeLatest, ForkEffect } from 'redux-saga/effects';
import ActionConstants from '../constants';
import workerSaga from './workerSaga';

// ------------------------------------
// Watchers
// ------------------------------------
export default function* onboardingWatcher(): Generator<
  ForkEffect<never>,
  void,
  unknown
> {
  yield takeLatest(ActionConstants.GET_PRODUCT_LISTING, workerSaga);
  yield takeLatest(ActionConstants.POST_SELECTED_PRODUCT_LISTING, workerSaga);
  yield takeLatest(ActionConstants.GET_STEP_DETAILS,workerSaga);
  yield takeLatest(ActionConstants.POST_SELF_SERVE_SAVE_AND_NEXT,workerSaga);
  yield takeLatest(ActionConstants.GET_DIGI_VERIFY,workerSaga);
  yield takeLatest(ActionConstants.GET_DIGI_DETAILS,workerSaga);
  yield takeLatest(ActionConstants.GET_PAN_AND_GST_DETAILS,workerSaga);
  yield takeLatest(ActionConstants.POST_PAN_VALIDATION, workerSaga);
  yield takeLatest(ActionConstants.POST_GST_VALIDATION, workerSaga);
  yield takeLatest(ActionConstants.GET_VIDEO_KYC_URL, workerSaga);
  yield takeLatest(ActionConstants.GET_VIDEO_KYC_STATUS, workerSaga);
  yield takeLatest(ActionConstants.GET_STATES_DATA,workerSaga);
  yield takeLatest(ActionConstants.GET_CITY_DATA,workerSaga);
  yield takeLatest(ActionConstants.UPDATE_REVIEW_STEP, workerSaga);
  yield takeLatest(ActionConstants.GET_MCC_DETAILS, workerSaga);
  yield takeLatest(ActionConstants.GET_KYC_IMAGE, workerSaga);
  yield takeLatest(ActionConstants.POST_BANK_ACCOUNT_VERIFICATION,workerSaga);
  yield takeLatest(ActionConstants.COMPLETE_VIDEO_KYC_JOURNEY,workerSaga);
  yield takeLatest(ActionConstants.POST_SEND_OTP_PDF, workerSaga);
  yield takeLatest(ActionConstants.POST_VERIFY_OTP_PDF, workerSaga);
  yield takeLatest(ActionConstants.SHOW_PDF, workerSaga);
  yield takeLatest(ActionConstants.SHOW_OPPORTUNITY_STATUS, workerSaga);
  yield takeLatest(ActionConstants.TOGGLE_ENVIRONMENT, workerSaga);
  yield takeLatest(ActionConstants.POST_CIN_NUMBER_VALIDATION, workerSaga);
  yield takeLatest(ActionConstants.CREATE_REVIEW_REQUEST, workerSaga);
  yield takeLatest(ActionConstants.DELETE_REVIEW_REQUEST, workerSaga);
  yield takeLatest(ActionConstants.CONFIRM_CHILD_SELECTION, workerSaga);
  yield takeLatest(ActionConstants.FETCH_UPLOAD_DOCUMENTS, workerSaga);
  yield takeLatest(ActionConstants.UPLOAD_DOCUMENT, workerSaga);
  yield takeLatest(ActionConstants.REJECTION_CLARIFICATION, workerSaga);
  yield takeLatest(ActionConstants.GENERATE_ESIGN_URL, workerSaga);
  yield takeLatest(ActionConstants.SEND_EMAIL_COMPANY_DIRECTOR, workerSaga);
  yield takeLatest(ActionConstants.GET_ESIGN_STATUS, workerSaga);
  yield takeLatest(ActionConstants.POST_KYC_VERIFICATION, workerSaga);
  yield takeLatest(ActionConstants.POST_PUBLIC_TOKEN_SELF_SERVE_VERIFICATION, workerSaga);
  yield takeLatest(ActionConstants.ADD_AND_UPDATE_BENEFICIARY, workerSaga);
  yield takeLatest(ActionConstants.RESEND_EMAIL_BENEFICIARY, workerSaga);
  yield takeLatest(ActionConstants.GET_BENEFICIARY_OWNERS, workerSaga);
  yield takeLatest(ActionConstants.PAN_KYC_AGREEMENT, workerSaga);
  yield takeLatest(ActionConstants.GET_AGREEMENT_ESIGN_URL, workerSaga);
  yield takeLatest(ActionConstants.GET_DOCUMENT_ESIGN_STATUS, workerSaga);
  yield takeLatest(ActionConstants.GET_AGREEMENT_ESIGN_STATUS, workerSaga);
  yield takeLatest(ActionConstants.SEND_EMAIL_KYC_AGREEMENT, workerSaga);
  yield takeLatest(ActionConstants.DOWNLOAD_REPORTS, workerSaga);
  yield takeLatest(ActionConstants.POST_SEND_VERIFICATION_CODE_CKYC, workerSaga);
  yield takeLatest(ActionConstants.POST_VERIFY_CKYC_CODE, workerSaga);
  yield takeLatest(ActionConstants.POST_DOWNLOAD_CKYC_DATA, workerSaga);
  yield takeLatest(ActionConstants.POST_MAP_CKYC_DATA, workerSaga);
  yield takeLatest(ActionConstants.SIDEBAR_STEP_CLICK, workerSaga);
  yield takeLatest(ActionConstants.POST_AUTOSAVE_STEP, workerSaga);
  yield takeLatest(ActionConstants.UPDATE_PCI_DSS_CONSENT, workerSaga);
}
  
